import styled from "styled-components";

export const StyledKBArticleCard = styled.div(
  ({ theme }) => `
    .uptime-accordion-details {
      padding: ${theme.uptimeSpace[12]}px;
      cursor: pointer;
      box-shadow: 4px 10px 30px 4px rgba(36, 14, 47, 0.06);
      border-radius: ${theme.uptimeSpace[5]}px !important;
      &:hover {
        box-shadow: 
        0 1px 2px -2px rgba(0, 0, 0, 0.16), 
        0 3px 6px 0 rgba(0, 0, 0 , 0.12),
        0 5px 12px 4px rgba(0, 0, 0, 0.09);
        border-color: transparent;
      }
      .type {
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        font-weight: bold;
        color: ${theme.uptimeColors.textColors.primary};
      }
      .cover {
        width: 45px;
        height: 45px;
        background-color: ${theme.uptimeColors.mainTheme.background};
        border-radius: ${theme.uptimeSpace[2]}px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .desc {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .title {
        margin-bottom: ${theme.uptimeDynamicAlignCenter?.topKnowledgeArticles?.marginBottomTitle ?? `${theme.uptimeSpace[0]}px`} !important;
        font-size: ${theme.uptimeDynamicFontSize?.kbArticleCard?.title};
        line-height: ${theme.uptimeLineHeights.desktop.lh4}px;
        font-weight: normal;
        color: ${theme.uptimeColors.textColors.primary};
        -webkit-line-clamp: 2;
      }
      .desc {
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
        color: ${theme.uptimeColors.textColors.primary};
        -webkit-line-clamp: 1;
      }
      .btn-detail {
        font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
        font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
        font-weight: 700;
        text-transform: none;
        &:hover {
          background-color: transparent;
        }
      }
      .rate {
        color: ${theme.uptimeColors.newsKnowledgeColors.rating};
        margin-right: ${theme.uptimeSpace[2]}px;
      }
      .viewcount{
        font-size: ${theme.uptimeDynamicFontSize?.kbArticleCard?.viewCount};
        line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
        font-weight: 600;
        color: ${theme.uptimeColors.grayScales.darkerGray};
        font-weight: normal;
      }
      .lastupdated{
        font-size: ${theme.uptimeDynamicFontSize?.kbArticleCard?.lastUpdate};
        line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
        font-weight: 600;
        color: ${theme.uptimeColors.grayScales.darkerGray};
        font-weight: normal;
      }
      .viewcount, .lastupdated {
        line-height: 1;
        margin-bottom: ${!!theme.uptimeDynamicAlignCenter ? (theme.uptimeDynamicAlignCenter?.topKnowledgeArticles?.marginBottomViewCountAndLastUpdate ?? 0) : 'unset'};
      }
      .activeHighlight{
        background-color: ${theme.uptimeColors.newsKnowledgeColors.highlight[0]};
      }
    }
    .icons{
      height: 16px;
    }
    .eyes-icons{
      margin-left: ${theme.uptimeSpace[10]}px;
    }
    .MuiPaper-elevation1{
      box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
    }
    .MuiPaper-root {
      background-color: ${theme.uptimeColors.grayScales.white};
    }
  `
);
